// Internal organs; coordinates for a 1.748 m adult male (whole group scaled by body height)
export const REF_H = 1.748;

export const ORGANS = [
  { id: "brain", zones: ["head"], label: [0, 1.75, 0.03], color: "#e8b4bc" },
  { id: "thyroid", zones: ["neck"], label: [0.035, 1.46, 0.07], color: "#b9474b" },
  { id: "trachea", zones: ["neck", "chest"], label: [0, 1.52, 0.05], color: "#e6c2b4" },
  { id: "lungs", zones: ["chest", "upper_back"], label: [0.085, 1.38, 0.03], color: "#e9a0a7" },
  { id: "heart", zones: ["chest"], label: [0.03, 1.3, 0.09], color: "#a8261f" },
  { id: "liver", zones: ["abdomen", "chest"], label: [-0.07, 1.19, 0.09], color: "#7f2f22" },
  { id: "stomach", zones: ["abdomen"], label: [0.07, 1.17, 0.09], color: "#d9887a" },
  { id: "gallbladder", zones: ["abdomen"], label: [-0.06, 1.1, 0.12], color: "#5c8a3a" },
  { id: "spleen", zones: ["abdomen", "upper_back"], label: [0.115, 1.19, 0.0], color: "#6e2436" },
  { id: "pancreas", zones: ["abdomen"], label: [0.02, 1.11, 0.06], color: "#e3b784" },
  { id: "kidneys", zones: ["lower_back", "abdomen"], label: [0.07, 1.13, -0.02], color: "#8e2f30" },
  { id: "intestines", zones: ["abdomen", "pelvis"], label: [0, 1.0, 0.1], color: "#dc9c86" },
  { id: "appendix", zones: ["abdomen", "pelvis"], label: [-0.085, 0.915, 0.07], color: "#c77a66" },
  { id: "urethra", zones: ["genitals"], label: [0.03, 0.83, 0.12], color: "#e8b04a" },
  { id: "testicles", zones: ["genitals"], sex: "male", label: [-0.04, 0.83, 0.09], color: "#d88e8e" },
  { id: "vagina", zones: ["genitals"], sex: "female", label: [-0.035, 0.85, 0.05], color: "#d47a8c" },
  { id: "bladder", zones: ["pelvis", "genitals"], label: [0, 0.905, 0.1], color: "#e2bd72" },
  { id: "prostate", zones: ["pelvis", "genitals"], sex: "male", label: [0, 0.845, 0.07], color: "#b56b76" },
  { id: "uterus", zones: ["pelvis", "genitals"], sex: "female", label: [0, 0.94, 0.07], color: "#cf6d7e" },
  { id: "ovaries", zones: ["pelvis", "genitals"], sex: "female", label: [0.065, 0.93, 0.05], color: "#e29fad" },
];

export const organsFor = (zone, sex) => ORGANS.filter((o) => o.zones.includes(zone) && (!o.sex || o.sex === sex));
